<template>
  <div id="home">
    <Nav />
    <Top />
    <Role />
    <Copyright />
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import Top from "@/components/Top.vue";
import Role from "@/components/Role.vue";
import Copyright from "@/components/Copyright.vue";

export default {
  components: {
    Nav, Top, Role, Copyright
  },
};
</script>
